export const _sgaFr = {
    sga: 'Système de gestion des alertes',
    createAlert: 'Créer une alerte',
    noAlert: 'Aucune alerte',
    cancelAlert: 'Annuler',
    location: 'Localisation',
    qualification: 'Qualification',
    city: 'Ville',
    address: 'Adresse',
    numero: 'Numéro',
    stage: 'Étage',
    gate: 'Porte',
    building: 'Bâtiment',
    code: 'Code',
    observations: 'Observations',
    locationInvalid: 'Localisation invalide',
    validate: 'Valider',
    update: 'Mettre à jour',
    waitingLocation: 'En attente de localisation',
    informations: 'Informations',
    engage: 'Engager',
    shareAndReturn: 'Partager et retourner à la liste',
    duration: 'Durée de traitement',
    callBackNumber: 'Numéro de contre appel',
    locationValid: 'Localisation valide',
    qualificationValid: 'Qualification valide',
    locationInvalid: 'Localisation invalide',
    qualificationInvalid: 'Qualification invalide',
    veryUrgent: 'Très urgent',
    urgent: 'Urgent',
    normal: 'Normal',
    low: 'Faible',
    ROAD_ACCIDENT: 'ACCIDENT DE LA ROUTE',
    HARM_PEOPLE: 'ATTEINTE AUX PERSONNES',
    HARM_ANIMALS_PROPERTY: 'ATTEINTE AUX ANIMAUX OU AUX BIENS',
    FIRE: 'INCENDIE',
    BLAST: 'EXPLOSION',
    OFFENSE: 'INFRACTION',
    PUBLIC_ORDER: 'TROUBLE A L\'ORDRE PUBLIC',
    NATURAL_HAZARD: 'RISQUE NATUREL',
    TECHNOLOGICAL_HAZARD: 'RISQUE TECHNOLOGIQUE',
    DISAPPEARANCES_DISCOVERIES: 'DISPARITIONS ET DECOUVERTES',
    OTHERS: 'AUTRES',
    START: 'DÉPART',
};

export const _sgaEn = {
    sga: 'Alert management system',
    createAlert: 'Create an alert',
    noAlert: 'No alert',
    cancelAlert: 'Cancel',
    location: 'Location',
    qualification: 'Qualification',
    city: 'City',
    address: 'Address',
    numero: 'Number',
    stage: 'Stage',
    gate: 'Gate',
    building: 'Building',
    code: 'Code',
    observations: 'Observations',
    locationInvalid: 'Invalid location',
    validate: 'Validate',
    update: 'Update',
    waitingLocation: 'Waiting for location',
    informations: 'Informations',
    engage: 'Engage',
    shareAndReturn: 'Share and return to the list',
    duration: 'Processing time',
    callBackNumber: 'Call back number',
    locationValid: 'Valid location',
    qualificationValid: 'Valid qualification',
    locationInvalid: 'Invalid location',
    qualificationInvalid: 'Invalid qualification',
    veryUrgent: 'Very urgent',
    urgent: 'Urgent',
    normal: 'Normal',
    low: 'Low',
    ROAD_ACCIDENT: 'ROAD ACCIDENT',
    HARM_PEOPLE: 'HARM TO PEOPLE',
    HARM_ANIMALS_PROPERTY: 'HARM TO ANIMALS OR PROPERTY',
    FIRE: 'FIRE',
    BLAST: 'BLAST',
    OFFENSE: 'OFFENSE',
    PUBLIC_ORDER: 'PUBLIC ORDER',
    NATURAL_HAZARD: 'NATURAL HAZARD',
    TECHNOLOGICAL_HAZARD: 'TECHNOLOGICAL HAZARD',
    DISAPPEARANCES_DISCOVERIES: 'DISAPPEARANCES AND DISCOVERIES',
    OTHERS: 'OTHERS',
    START: 'START',
};

export const _sgaDe = {
    sga: 'Alarmverwaltungssystem',
    createAlert: 'Alarm erstellen',
    noAlert: 'Kein Alarm',
    cancelAlert: 'Stornieren',
    location: 'Ort',
    qualification: 'Qualifikation',
    city: 'Stadt',
    address: 'Adresse',
    numero: 'Nummer',
    stage: 'Bühne',
    gate: 'Tor',
    building: 'Gebäude',
    code: 'Code',
    observations: 'Beobachtungen',
    locationInvalid: 'Ungültiger Standort',
    validate: 'Bestätigen',
    update: 'Aktualisieren',
    waitingLocation: 'Warten auf Standort',
    informations: 'Informationen',
    engage: 'Engagieren',
    shareAndReturn: 'Teilen und zurück zur Liste',
    duration: 'Bearbeitungszeit',
    callBackNumber: 'Rückrufnummer',
    locationValid: 'Gültiger Standort',
    qualificationValid: 'Gültige Qualifikation',
    locationInvalid: 'Ungültiger Standort',
    qualificationInvalid: 'Ungültige Qualifikation',
    veryUrgent: 'Sehr dringend',
    urgent: 'Dringend',
    normal: 'Normal',
    low: 'Niedrig',
    ROAD_ACCIDENT: 'VERKEHRSUNFALL',
    HARM_PEOPLE: 'SCHADEN AN PERSONEN',
    HARM_ANIMALS_PROPERTY: 'SCHADEN AN TIEREN ODER EIGENTUM',
    FIRE: 'FEUER',
    BLAST: 'EXPLOSION',
    OFFENSE: 'VERGEHEN',
    PUBLIC_ORDER: 'ÖFFENTLICHE ORDNUNG',
    NATURAL_HAZARD: 'NATURGEFAHR',
    TECHNOLOGICAL_HAZARD: 'TECHNOLOGISCHE GEFAHR',
    DISAPPEARANCES_DISCOVERIES: 'VERSCHWINDEN UND ENTDECKUNGEN',
    OTHERS: 'ANDERE',
    START: 'START',
};
